import styled from "styled-components";

import { metrics } from "../../AllowableVsPtResponsibility/helpers";

const StyledList = styled.ul`
  li::marker {
    color: var(--primary-color);
  }
`;

const StyledCard = styled.div`
  border: 1px solid #eaecf0;
  border-radius: 12px;
  img {
    border-radius: 100%;
  }
`;

const StyledHeader = styled.div`
  background-image: url("/ai_background.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 10px;
  border-radius: 12px 12px 0 0;
  border-bottom: 1px solid #f2f4f7;
`;

export function Metrics() {
  return (
    <div className="lg:w-6 w-full p-4">
      <StyledCard>
        <StyledHeader className="flex gap-4 align-items-center">
          <img src="/ai.png" alt="ai logo" />
          <div className="flex flex-column gap-1">
            <p className="text-xl font-semibold text-gray-new-900">
              Key Metrics and Their Implications
            </p>
          </div>
        </StyledHeader>
        <div className="p-4">
          <StyledList className="flex flex-column gap-3">
            {metrics.map((metric, index) => (
              <li key={index} className="ml-4">
                <span className="font-semibold text-primary text-sm">
                  {metric.title}{" "}
                </span>
                <span className="text-sm">{metric.description}</span>
                {metric.items && (
                  <StyledList className="list-disc pl-5 mt-2">
                    {metric.items.map((item, itemIndex) => (
                      <li key={itemIndex}>
                        <span className="font-semibold text-primary text-sm">
                          {item.title}{" "}
                        </span>
                        <span className="text-sm">{item.description}</span>
                      </li>
                    ))}
                  </StyledList>
                )}
              </li>
            ))}
          </StyledList>
        </div>
      </StyledCard>
    </div>
  );
}
